export default __webpack_public_path__ + "static/media/innovationBox.466821c5.png";